import React from 'react'

import RiparideLogo from 'components/icons/RiparideSmallLogo'
import ButtonLink from 'components/display/ButtonLink'
import { marketAlertContent } from './content'
import {
  Alert,
  LogoWrapper,
  ContentWrapper,
  Heading,
  Paragraph,
  ButtonWrapper,
} from './styles'

type InvitedProps = {
  marketCode: string
  isInvited: true
  search: string
}

type UninvitedProps = {
  marketCode: string
  isInvited: false
  search?: string
}

type MarketAlertProps = InvitedProps | UninvitedProps

type MarketAlertContentProps = {
  market: String
  heading: String
  text: React.ReactNode
}

const MarketAlert = ({
  marketCode: rawMarketCode,
  isInvited,
  search,
}: MarketAlertProps) => {
  const alertableMarkets = ['wa', 'or', 'ca']
  const marketCode = rawMarketCode?.toLowerCase()
  const href = isInvited ? `/set-password${search}` : '/my/listings/new'

  const alertContent = marketAlertContent.find(
    (content: MarketAlertContentProps) => content.market === marketCode
  )

  return alertableMarkets.includes(marketCode) && alertContent ? (
    <Alert>
      <LogoWrapper>
        <RiparideLogo />
      </LogoWrapper>

      <ContentWrapper>
        <Heading>{alertContent.heading}</Heading>
        <Paragraph>{alertContent.text}</Paragraph>
      </ContentWrapper>

      <ButtonWrapper>
        <ButtonLink href={href} rounded>
          Become a host
        </ButtonLink>
      </ButtonWrapper>
    </Alert>
  ) : (
    <></>
  )
}

export default MarketAlert
